export const slugify = (text) => {
    return text
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')       
        .replace(/[^\w-]+/g, '')    
        .replace(/--+/g, '-');    
};